module.exports = __webpack_public_path__ + "static/AMOEBAFILM-559cac1b91e3f71b64f133f3262ec392.mp4";